import type { PropsWithChildren } from 'react'
import { Icon } from '../Icon';

type RecipientDisplayNameProps = PropsWithChildren & {
  variant?: 'user' | 'company'
};

export const RecipientDisplayName = ( { variant, children }: RecipientDisplayNameProps ) => {

  return (
    <div className={ 'flex flex-row gap-3 items-center leading-[18px]' }>
      <Icon
        name={ variant === 'company' ? 'briefcase' : 'user-alt-1' }
        className={ 'text-base w-4 h-4' } />
      {children}
    </div>
  )
}
RecipientDisplayName.displayName = 'RecipientDisplayName';
